import { Delete02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Stack,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  useTheme,
} from '@mui/material';
interface ConfirmationDialog {
  isOpen: boolean;
  title?: string;
  action?: string;
  message: string;
  isLoading?: boolean;
  onSubmit?: () => void;
  onClose: () => void;
}

const ConfirmationDialog = ({
  isOpen,
  title = 'Confirmación',
  action = 'Eliminar',
  message,
  isLoading= false,
  onSubmit = () => undefined,
  onClose = () => undefined,
}: ConfirmationDialog) => {
  const theme = useTheme();
  
  return (
    <Box>
      <Dialog
        open={isOpen}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="xl"
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: 600,
            }}
          >
            <Stack spacing={2} flex={1} justifyContent="center" alignItems="center">
              <HugeiconsIcon icon={Delete02Icon} size={64} strokeWidth={1} />
              <Typography variant="body1" textAlign="center">{message}</Typography>
            </Stack>
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: 3, paddingTop: 0 }}>
          <Button variant="text" onClick={onClose}>Cancelar</Button>
          <Button
            variant="contained"
            color="error"
            disableElevation
            onClick={onSubmit}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={22} color={theme.palette.error.contrastText} /> : action}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ConfirmationDialog;
